export const mapItemsInOrder = (items: number): string | undefined => {
  if (items === 0) return '0'
  if (items === 1) return '1'
  if (items === 2) return '2'
  if (items === 3 || items === 4) return '3-4'
  if (items > 4) return '5 or more'
  return undefined
}

export const maskEmailAddress = (email: string): string => {
  return email.replace(/^(.*)(..)(@(.*))$/, (_, a, b, c) => a.replace(/./g, '*') + b + c)
}
